import { useEffect, useState } from "react";
import { ClioService } from "../../../api";
import { LitigationFunnelMatter } from "../../../api/models/LitigationFunnelMatter";
import { MediationAreas } from "../Common/Areas";
import { LitigationReportRequest } from "../../../api/models/LitigationReportRequest";
import { MatterData } from "../../../api/models/MatterData";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { startSpinner, stopSpinner } from "../../../redux/actions/spinnerActions";
import { useDispatch } from "react-redux";
import StagesReport from "../Common/StagesReport";

const MySwal = withReactContent(Swal);

export default function MediationReport() {
    const [matters, setMatters] = useState<LitigationFunnelMatter[]>([]);
    const [matterOptions, setMatterOptions] = useState<MatterData[]>([]);

    const dispatch = useDispatch();

    const loadReport = (reportFilter: LitigationReportRequest) => {
        dispatch(startSpinner());
        ClioService.postApiClioMediationReport(reportFilter).then((matters) => {
            setMatters(matters);
            dispatch(stopSpinner());
        }).catch(err => {
            MySwal.fire({
                icon: "error",
                title: <p className="title">Error loading data</p>,
            });
            dispatch(stopSpinner());
        });
    }

    useEffect(() => {
        ClioService.getApiClioMediationMatters().then((matters) => {
            setMatterOptions(matters.sort((a, b) => {
                const aName = `${a.display_number}`;
                const bName = `${b.display_number}`;
                return aName.localeCompare(bName)
            }));
        });
    }, [])

    console.log('matters ', matters)
    console.log('matters options ', matterOptions)

    return (
        <StagesReport
            matters={matters}
            matterOptions={matterOptions}
            loadReport={loadReport}
            areas={MediationAreas}
        />);
}
